// extracted by mini-css-extract-plugin
export default {"formWrapper":"Login_formWrapper__gt+kc","card":"Login_card__YJUeE"};